import React from 'react'
import { PageContent, Heading, Message, Text, Image } from 'components/library'

import iconArrow from './assets/arrow-down.svg'
import iconArrowLeft from './assets/arrow-left2.svg'

import audio01 from './assets/APC_OverschakelenLVNL.mp3'
import audio02 from './assets/Sleper_overschakelenLVNL_2.mp3'
import audio03 from './assets/Sleper_Aanmelden-toren.mp3'
import audio04 from './assets/Toren_aanmelden.mp3'
import audio05 from './assets/Sleper_aanvraagbaankruising.mp3'
import audio06 from './assets/Toren_toestemmingbaankruising.mp3'
import audio07 from './assets/Sleper_Baankruisingtoegestaan.mp3'
import audio08 from './assets/Sleper_Vrijmeldenbaan_2.mp3'
import audio09 from './assets/Toren_vrijmeldenbaankruising.mp3'
import audio10 from './assets/Toren_Wachten.mp3'
import audio11 from './assets/Sleper_wachten_01.mp3'

import './Aspect02.css'

class Aspect02 extends React.Component {

  render() {
    return (
      <div className="Chapter05-Aspect02">
        <PageContent>

          <Message task icon="play">
            <Text>Beluister onderstaande fragmenten om voorbeelden te horen van standaardberichten</Text>
          </Message>

          <div className="Aspect-section-01">
            <div className="is-header">
              <Heading h3>Apron Control Opdracht</Heading>
            </div>
            <div>
              <div>
                <div>
                  <Text><strong>Apron Control opdracht</strong></Text>
                  <Text>Je (verkorte) registratie + over naar Toren</Text>
                </div>
                <div>
                  <audio controls controlsList="nodownload">
                    <source src={audio01} type="audio/ogg"/>
                    <source src={audio01} type="audio/mpeg"/>
                  </audio>
                </div>
              </div>
            </div>
            <div className="has-background-color">
              <div>
                <div>
                  <Text><strong>Sleper antwoord</strong></Text>
                  <Text>Je (verkorte) registratie + over naar Toren</Text>
                </div>
                <div>
                  <audio controls controlsList="nodownload">
                    <source src={audio02} type="audio/ogg"/>
                    <source src={audio02} type="audio/mpeg"/>
                  </audio>
                </div>
              </div>
            </div>
            <div>
              <div className="Icon-arrow is-centered">
                <Image src={iconArrow} aspectRatio={100}/>
              </div>
            </div>
          </div>

          <div className="Aspect-section-02">
            <div className="is-header">
              <Heading h3>Aanvraag en vrijmelden baankruising via LVNL</Heading>
            </div>
            <div>
              <div>
                <div>
                  <Text><strong>Sleper oproep</strong></Text>
                  <Text>Toren + je (verkorte) registratie</Text>
                </div>
                <div>
                  <audio controls controlsList="nodownload">
                    <source src={audio03} type="audio/ogg"/>
                    <source src={audio03} type="audio/mpeg"/>
                  </audio>
                </div>
              </div>
            </div>
            <div className="has-background-color">
              <div>
                <div>
                  <Text><strong>LVNL antwoord</strong></Text>
                  <Text>Je (verkorte) registratie + Toren</Text>
                </div>
                <div>
                  <audio controls controlsList="nodownload">
                    <source src={audio04} type="audio/ogg"/>
                    <source src={audio04} type="audio/mpeg"/>
                  </audio>
                </div>
              </div>
            </div>
            <div>
              <div>
                <div>
                  <Text><strong>Sleper aanvraag</strong></Text>
                  <Text>Je (verkorte) registratie + locatie + baan X + kruisen</Text>
                </div>
                <div>
                  <audio controls controlsList="nodownload">
                    <source src={audio05} type="audio/ogg"/>
                    <source src={audio05} type="audio/mpeg"/>
                  </audio>
                </div>
              </div>
            </div>
            <div className="has-display-flex">
              <div className="Icon-arrow is-centered">
                <Image src={iconArrow} aspectRatio={100}/>
              </div>
              <div className="Icon-arrow is-centered">
                <Image src={iconArrow} aspectRatio={100}/>
              </div>
            </div>
          </div>

          <div className="Aspect-section-03">
            <div className="col-01">
              <div className="is-header">
                <Heading h3>Je krijgt toestemming</Heading>
              </div>
              <div>
                <div>
                  <Text><strong>LVNL antwoord</strong></Text>
                  <Text>Je (verkorte) registratie + locatie + baan X + kruisen toegestaan</Text>
                </div>
                <div>
                  <audio controls controlsList="nodownload">
                    <source src={audio06} type="audio/ogg"/>
                    <source src={audio06} type="audio/mpeg"/>
                  </audio>
                </div>
              </div>
              <div className="has-background-color">
                <div>
                  <Text><strong>Sleper teruglezen</strong></Text>
                  <Text>Je (verkorte) registratie + locatie + baan X + kruisen toegestaan</Text>
                </div>
                <div>
                  <audio controls controlsList="nodownload">
                    <source src={audio07} type="audio/ogg"/>
                    <source src={audio07} type="audio/mpeg"/>
                  </audio>
                </div>
              </div>
              <div>
                <div>
                  <Text><strong>Sleper vrijmelden</strong></Text>
                  <Text>Je (verkorte) registratie + baan X + locatie + vrij</Text>
                </div>
                <div>
                  <audio controls controlsList="nodownload">
                    <source src={audio08} type="audio/ogg"/>
                    <source src={audio08} type="audio/mpeg"/>
                  </audio>
                </div>
              </div>
              <div className="has-background-color">
                <div>
                  <Text><strong>LVNL teruglezen</strong></Text>
                  <Text>Je (verkorte) registratie + baan X + locatie + vrij</Text>
                </div>
                <div>
                  <audio controls controlsList="nodownload">
                    <source src={audio09} type="audio/ogg"/>
                    <source src={audio09} type="audio/mpeg"/>
                  </audio>
                </div>
              </div>
              <div className="Icon-arrow is-centered">
                <Image src={iconArrow} aspectRatio={100}/>
              </div>
            </div>
            <div className="col-02">
              <div className="Icon-arrow is-centered">
                <Image src={iconArrowLeft} aspectRatio={100}/>
              </div>
            </div>
            <div className="col-03">
              <div className="is-header">
                <Heading h3>Je moet wachten op toestemming</Heading>
              </div>
              <div>
                <div>
                  <Text><strong>LVNL antwoord</strong></Text>
                  <Text>Je (verkorte) registratie + wachten</Text>
                </div>
                <div>
                  <audio controls controlsList="nodownload">
                    <source src={audio10} type="audio/ogg"/>
                    <source src={audio10} type="audio/mpeg"/>
                  </audio>
                </div>
              </div>
              <div className="has-background-color">
                <div>
                  <Text><strong>Sleper teruglezen</strong></Text>
                  <Text>Je (verkorte) registratie + wachten</Text>
                </div>
                <div>
                  <audio controls controlsList="nodownload">
                    <source src={audio11} type="audio/ogg"/>
                    <source src={audio11} type="audio/mpeg"/>
                  </audio>
                </div>
              </div>
            </div>
          </div>

          <div className="Aspect-section-04">
            <Heading h3>Je schakelt op eigen initiatief terug naar Apron Control</Heading>
          </div>

        </PageContent>
      </div>
    )
  }
}

export default Aspect02



// WEBPACK FOOTER //
// ./src/content/chapters/05/02/Aspect02.js